<!--
@component File selector with icons an text.

   Main properties:
   - `file` - bindable property to get the selected file
   - `message` - message text to show on the selector, default: `'Select CSV file with dataset'`.
   - `acceptType` - pattern - which files to accept, default: `'.csv'`.
-->
<script>
   import ButtonCancel from './ButtonCancel.svelte'
   let {
      file = $bindable(),                        // container to get return the uploaded file
      message = 'Select CSV file with dataset',  // message to show when no file is selected
      acceptType = '.csv',                       // file type to accept
   } = $props();

   let fileInput;

   /* change value for 'file' parameter when user selects or deselects file */
   function changeStatus(e) {
      if (fileInput && fileInput.files.length > 0) {
         file = fileInput.files[0];
      } else {
         file = null;
      }
   }

   /* activate file selection input if user hit Enter or Spacebar when being on label */
   function activateInput(e) {
      if (e.type === 'click' || (e.type === 'keydown' && (e.code === 'Space' || e.code === 'Enter'))) fileInput.click();
   }

   /* resets selection */
   function reset(e) {
      fileInput.value = null;
      file = null;
   }
</script>

<div tabindex="0" onkeydown={activateInput} onclick={activateInput} role="radiogroup" class="file-selector" class:selected={file}>
   { file ? file.name : message }
   <input onchange={changeStatus} bind:this={fileInput} type="file" accept={acceptType}>
</div>
{#if file}
<ButtonCancel onclick={reset}/>
{/if}

<style>
   .file-selector > input {
      display: none;
   }

   .file-selector {
      display: flex;
      align-items: baseline;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      flex: 1 1;
      min-width: 0;
      border-radius: 2px;
      cursor: default;
   }

   .file-selector:focus-visible {
      outline: solid 2px;
      outline-offset: 2px;
   }

   .file-selector::before {
      display: inline-block;
      content: '\21ea';
      font-size: 1.1em;
      margin: 0 0.5em 0 0em;
      padding: 0;
   }

   .file-selector.selected::before {
      content: '\2637';
      font-size: 1.3em;
      letter-spacing: -.2em;
      font-weight: bold;
   }
</style>
